<template>
  <main>
    <div class="main-wrapper" :class="{zoom: $store.getters['menu/getZoom'], 'form-in': $store.getters['menu/getForm']}">
      <div class="contents-wrapper" :class="{selected: $store.getters['menu/getSelected']}">
        <google-map v-if="showMap" class="google-map-wrapper" @getCurrentPosition="getCurrentPosition"></google-map>
      </div>
      <register-form :class="{'form-in': $store.getters['menu/getForm']}"></register-form>
      <image-add-form :class="{'form-in': $store.getters['menu/getAddForm']}"></image-add-form>
    </div>
    <transition name="fade">
      <div class="launch" v-show="showLaunch"></div>
    </transition>
  </main>
</template>

<script>
import utils from '../../../utils/vue/Utils'
import GoogleMap from '../../../components/map/vue/GoogleMap'
import RegisterForm from '../../../components/register/vue/RegisterForm'
import ImageAddForm from '../../../components/register/vue/ImageAddForm'
import store from '../../../vuex'

export default {
  name: 'top',
  data () {
    return {
      showLaunch: true
    }
  },
  created () {
    this.callScript('https://maps.googleapis.com/maps/api/js?key=' + this.variable.methods.getAccessKey(), () => {
      window.initMap = () => {}
      this.getCurrentPosition()
      setTimeout(() => {
        this.showLaunch = false
      }, 1000)
    })
  },
  methods: {
    getCurrentPosition () {
      this.showMap = false
      const defaultLocation = this.variable.methods.defaultLocation()
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          store.dispatch('centerLatLng/setLat', position.coords.latitude)
          store.dispatch('centerLatLng/setLng', position.coords.longitude)
          store.dispatch('centerLatLng/setCurrent', true)
          this.showMap = true
          this.getMarkerCoordinates()
        }, () => {
          this.showModal(this.constant.modal.util)
          this.store.dispatch('modal/setMessage1', '位置情報が取得できませんでした')
          store.dispatch('centerLatLng/setLat', defaultLocation.lat)
          store.dispatch('centerLatLng/setLng', defaultLocation.lng)
          this.showMap = true
          this.getMarkerCoordinates()
        }, {
          'enableHighAccuracy': false,
          'timeout': 8000,
          'maximumAge': 5000
        })
      } else {
        this.showModal(this.constant.modal.util)
        this.store.dispatch('modal/setMessage1', 'この端末では位置情報が取得できません')
        store.dispatch('centerLatLng/setLat', defaultLocation.lat)
        store.dispatch('centerLatLng/setLng', defaultLocation.lng)
        this.showMap = true
      }
    }
  },
  components: {
    GoogleMap,
    RegisterForm,
    ImageAddForm
  },
  mixins: [utils]
}
</script>

<style lang="scss" scoped src="../scss/Top.scss"></style>



// WEBPACK FOOTER //
// src/pages/top/vue/Top.vue